import React, { useState, useEffect } from 'react';
import { FaHome, FaImages, FaFileAlt, FaPlus, FaTrash, FaEye, FaSignOutAlt, FaTimes } from 'react-icons/fa';
import './admin.css';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
const url="https://eylocoin-site.stackstaging.com/"
function AdminDashboard() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('portfolio');
    const [portfolioItems, setPortfolioItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [resumeFile, setResumeFile] = useState(null);
    const [currentResumeUrl, setCurrentResumeUrl] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        category: '',
        image: '',
        description: ''
    });
    const [successMessage, setSuccessMessage] = useState('');

    const [resumeList, setResumeList] = useState([]);

    const handleLogout = () => {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('isAdmin');
        navigate('/');
    };
    // Sample data
    // const samplePortfolioItems = [
    //     {
    //         id: 1,
    //         image: 'https://source.unsplash.com/400x300/?abstract',
    //         title: 'Product Admin Dashboard',
    //         category: 'UI-UX DESIGN',
    //         description: 'Modern dashboard design for product management'
    //     },
    //     {
    //         id: 2,
    //         image: 'https://source.unsplash.com/400x300/?technology',
    //         title: 'E-Commerce Admin Dashboard',
    //         category: 'UI-UX DESIGN',
    //         description: 'Complete e-commerce management interface'
    //     }
    // ];
    useEffect(() => {
        const fetchResumes = async () => {
            try {
                const res = await fetch(`${url}portfoilo/resume.php`);
                const data = await res.json();
                setResumeList(data.files || []);
            } catch (err) {
                console.error('Failed to fetch resume list:', err);
            }
        };

        fetchResumes();
    }, []);
    const [contactsList, setContactsList] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);

    const handleViewContact = (index) => {
        setSelectedContact(contactsList[index]);
    };
    const handleCloseModal = () => {
        setSelectedContact(null);
    };
    useEffect(() => {
        fetch(`${url}portfoilo/get_contacts.php`)
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setContactsList(data.contacts);
                }
            })
            .catch((err) => console.error(err));
    }, []);

    const handleResumeUpload = async () => {
        if (!resumeFile) {
            alert('Please select a PDF first.');
            return;
        }

        const formData = new FormData();
        formData.append('resume', resumeFile);

        try {
            setIsUploading(true);
            const res = await fetch(`${url}portfoilo/resume.php`, {
                method: 'POST',
                body: formData,
            });

            const data = await res.json();
            if (data.success) {
                alert('Resume uploaded successfully!');
                setCurrentResumeUrl(`${url}portfoilo/${data.url}`);
                setResumeFile(null);
            } else {
                alert('Upload failed.');
            }
        } catch (err) {
            console.error(err);
            alert('Upload failed.');
        } finally {
            setIsUploading(false);
        }
    };
    const fetchPortfolio = async () => {
        setIsLoading(true);
        try {
            const res = await fetch(`${url}portfoilo/portfolio.php`);
            const data = await res.json();
            setPortfolioItems(data);
        } catch (error) {
            console.error('Fetch error:', error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {


        fetchPortfolio();
    }, []);


    // useEffect(() => {
    //     setIsLoading(true);
    //     // Simulate API call
    //     setTimeout(() => {
    //         setPortfolioItems(samplePortfolioItems);
    //         setIsLoading(false);
    //     }, 1000);
    // }, []);
    const handleDeleteResume = async (filename) => {
        const confirm = window.confirm(`Delete ${filename}?`);
        if (!confirm) return;

        try {
            const res = await fetch(`${url}portfoilo/resume.php`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ filename }),
            });

            const data = await res.json();
            if (data.success) {
                alert('Deleted successfully.');
                setResumeList((prev) => prev.filter((f) => f !== filename));
            } else {
                alert('Delete failed.');
            }
        } catch (err) {
            console.error('Delete error:', err);
            alert('Delete failed.');
        }
    };

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm('Are you sure you want to delete this item?');
        if (!confirmDelete) return;

        try {
            const res = await fetch(`${url}portfoilo/portfolio.php?id=${id}`, {
                method: 'DELETE',
            });

            const data = await res.json();

            if (data.success) {
                // Remove from local state
                setPortfolioItems(prev => prev.filter(item => item.id !== id));
            } else {
                alert('Failed to delete on server.');
            }
        } catch (error) {
            console.error('Delete failed:', error);
            alert('Could not delete. Please try again.');
        }
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image') {
            setFormData(prev => ({
                ...prev,
                image: files[0]
            }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setSuccessMessage('');
        setError('');

        const formDataToSend = new FormData();
        formDataToSend.append('title', formData.title);
        formDataToSend.append('category', formData.category);
        formDataToSend.append('description', formData.description);
        if (formData.id) formDataToSend.append('id', formData.id);
        if (formData.image && formData.image instanceof File) {
            formDataToSend.append('image', formData.image);
        }

        try {
            const res = await fetch(`${url}portfoilo/portfolio.php`, {
                method: 'POST',
                body: formDataToSend,
            });

            const data = await res.json();
            console.log(data);

            if (data.success) {
                 fetchPortfolio();
                setSuccessMessage('Portfolio item saved successfully!');
                // Reset form
                setFormData({
                    id: '',
                    title: '',
                    category: '',
                    description: '',
                    image: null,
                });
            } else {
                setError(data.message || 'Something went wrong');
            }
        } catch (err) {
            console.error(err);
            setError('Error submitting form');
        } finally {
            setIsLoading(false);
        }
    };



    const renderDashboard = () => (
        <div className="dashboard-content">
            <h2>Dashboard Overview</h2>
            <div className="stats-grid">
                <div className="stat-card">
                    <h3>Portfolio Items</h3>
                    <p>{portfolioItems.length}</p>
                </div>
                <div className="stat-card">
                    <h3>Categories</h3>
                    <p>{new Set(portfolioItems.map(item => item.category)).size}</p>
                </div>
                <div className="stat-card">
                    <h3>Last Updated</h3>
                    <p>Today</p>
                </div>
            </div>
            <div className="recent-activity">
                <h3>Recent Activity</h3>
                <ul>
                    <li>Added new portfolio item: E-Commerce Dashboard</li>
                    <li>Updated portfolio categories</li>
                    <li>Deleted old project</li>
                </ul>
            </div>
        </div>
    );

    const renderPortfolio = () => (
        <div className="portfolio-content">
            <div className="section-header">
                <h2>Portfolio Management</h2>
                <button
                    className="add-btn"
                    onClick={() => {
                        setFormData({ title: '', category: '', image: '', description: '' });
                        setActiveTab('add-portfolio');
                    }}
                >
                    <FaPlus /> Add Item
                </button>
            </div>

            {isLoading ? (
                <div className="loading-spinner">
                    <div className="spinner"></div> Loading...
                </div>
            ) : portfolioItems.length === 0 ? (
                <div className="empty-state">
                    <FaImages size={48} />
                    <p>No portfolio items yet. Add your first item.</p>
                    <button
                        className="add-btn"
                        onClick={() => setActiveTab('add-portfolio')}
                    >
                        <FaPlus /> Add Item
                    </button>
                </div>
            ) : (
                <div className="portfolio-grid">
                    {portfolioItems.map((item) => (
                        <div key={item.id} className="portfolio-card">
                            <img src={`${url}portfoilo/${item.image}`} alt={item.title} />

                            <div className="portfolio-content">
                                <span>{item.category}</span>
                                <h3>{item.title}</h3>
                                <p className='truncate-3-lines'>{item.description}</p>
                                {/* <a href="#" className="case-study">Case Study →</a> */}
                                <div className="item-actions">
                                    <button
                                        className="view-btn"
                                        onClick={() => {
                                            setSelectedItem(item);
                                            setShowModal(true);
                                        }}
                                    >
                                        <FaEye /> View
                                    </button>
                                    <button
                                        className="delete-btn"
                                        onClick={() => handleDelete(item.id)}
                                    >
                                        <FaTrash /> Delete
                                    </button>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
                // <div className="portfolio-list">
                //     {portfolioItems.map((item) => (
                //         <div key={item.id} className="portfolio-item">
                //             <div className="item-image">
                //                 <img src={item.image} alt={item.title} />
                //             </div>
                //             <div className="item-details">
                //                 <h3>{item.title}</h3>
                //                 <span className="item-category">{item.category}</span>
                //                 <p className="item-description">{item.description}</p>
                //             </div>
                // <div className="item-actions">
                //     <button
                //         className="view-btn"
                //         onClick={() => {
                //             setSelectedItem(item);
                //             setShowModal(true);
                //         }}
                //     >
                //         <FaEye /> View
                //     </button>
                //     <button
                //         className="delete-btn"
                //         onClick={() => handleDelete(item.id)}
                //     >
                //         <FaTrash /> Delete
                //     </button>
                // </div>
                //         </div>
                //     ))}
                // </div>
            )}
        </div>
    );

    const renderAddPortfolio = () => (
        <div className="add-portfolio-content">
            <div className="section-header">
                <h2>{formData.id ? 'Edit Portfolio Item' : 'Add New Portfolio Item'}</h2>
                <button
                    className="back-btn"
                    onClick={() => setActiveTab('portfolio')}
                >
                    Back to Portfolio
                </button>
            </div>
            {successMessage && <div className="success-message">{successMessage}</div>}

            {error && <div className="error-message">{error}</div>}

            <form className="upload-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Title</label>
                    <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label>Category</label>
                    <input
                        type="text"
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label>Description</label>
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group file-upload">
                    <label>
                        <FaPlus /> Upload Image
                        <input
                            type="file"
                            name="image"
                            accept="image/*"
                            onChange={handleChange}
                            required={!formData.id}
                        />
                    </label>
                    {formData.image && (
                        <span className="file-name">
                            {formData.image.name || 'Selected'}
                        </span>
                    )}
                </div>
                <button
                    type="submit"
                    className="submit-btn"
                    disabled={isLoading}
                >
                    {isLoading ? 'Saving...' : 'Save Item'}
                </button>
            </form>
        </div>
    );

    const renderResume = () => (
        <div className="resume-content">
            <h2>Resume Management</h2>

            <div className="resume-upload">
                <h3>Upload Resume</h3>
                <div className="file-upload">
                    <label>
                        <FaFileAlt /> Choose PDF File
                        <input
                            type="file"
                            accept=".pdf"
                            onChange={(e) => {
                                if (e.target.files[0]) {
                                    setResumeFile(e.target.files[0]);
                                }
                            }}
                        />
                    </label>
                    {resumeFile && <p>Selected: {resumeFile.name}</p>}
                </div>

                <button
                    className="submit-btn"
                    onClick={handleResumeUpload}
                    disabled={isUploading}
                >
                    {isUploading ? 'Uploading...' : 'Upload Resume'}
                </button>
            </div>

            <div className="current-resume">
                <h3>All Uploaded Resumes</h3>
                {resumeList.length > 0 ? (
                    <ul className="resume-list">
                        {resumeList.map((file) => (
                            <li key={file}>
                                <a
                                    href={`${url}portfoilo/resume/${file}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {file}
                                </a>
                                <button
                                    className="delete-btn"
                                    onClick={() => handleDeleteResume(file)}
                                >
                                    Delete
                                </button>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No resumes uploaded yet.</p>
                )}
            </div>
        </div>
    );


    const renderContacts = () => (
        <div className="contacts-content">
            <h2>Contact Management</h2>

            <div className="current-contacts">
                <h3>All Submitted Contacts</h3>
                {contactsList.length > 0 ? (
                    <table className="contacts-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Subject</th>
                                <th>Timestamp</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contactsList.map((contact, index) => (
                                <tr key={index}>
                                    <td>{contact.name}</td>
                                    <td>{contact.email}</td>
                                    <td>{contact.subject}</td>
                                    <td>{contact.timestamp}</td>
                                    <td>
                                        <button
                                            className="view-btn"
                                            onClick={() => handleViewContact(index)}
                                        >
                                            View
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p>No contacts submitted yet.</p>
                )}

                {selectedContact && (
                    <div className="admin-modal-overlay" onClick={handleCloseModal}>
                        <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
                            <h4>Contact Details</h4>
                            <p><strong>Name:</strong> {selectedContact.name}</p>
                            <p><strong>Email:</strong> {selectedContact.email}</p>
                            <p><strong>Location:</strong> {selectedContact.location}</p>
                            <p><strong>Budget:</strong> {selectedContact.budget}</p>
                            <p><strong>Subject:</strong> {selectedContact.subject}</p>
                            <p><strong>Message:</strong> {selectedContact.message}</p>
                            <p><strong>Timestamp:</strong> {selectedContact.timestamp}</p>
                            <button className="admin-close-btn" onClick={handleCloseModal}>Close</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );




    return (
        <div className="admin-dashboard">
            <div className="sidebar">
                <div className="sidebar-header">
                    <h2>Admin Panel</h2>
                </div>
                <nav className="sidebar-nav">
                    <button
                        className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
                        onClick={() => setActiveTab('dashboard')}
                    >
                        <FaHome /> Dashboard
                    </button>
                    <button
                        className={`nav-item ${activeTab === 'portfolio' ? 'active' : ''}`}
                        onClick={() => setActiveTab('portfolio')}
                    >
                        <FaImages /> Portfolio
                    </button>
                    <button
                        className={`nav-item ${activeTab === 'resume' ? 'active' : ''}`}
                        onClick={() => setActiveTab('resume')}
                    >
                        <FaFileAlt /> Resume
                    </button>
                    <button
                        className={`nav-item ${activeTab === 'contact' ? 'active' : ''}`}
                        onClick={() => setActiveTab('contact')}
                    >
                        <FaFileAlt /> contact
                    </button>
                </nav>
                <button className="logout-btn" onClick={handleLogout}>
                    <FaSignOutAlt /> Logout
                </button>
            </div>

            <div className="main-content">
                {activeTab === 'dashboard' && renderDashboard()}
                {activeTab === 'portfolio' && renderPortfolio()}
                {activeTab === 'add-portfolio' && renderAddPortfolio()}
                {activeTab === 'resume' && renderResume()}
                {activeTab === 'contact' && renderContacts()}
            </div>

            {showModal && selectedItem && (
                <div className="admin-modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-modal" onClick={() => setShowModal(false)}>
                            <FaTimes />
                        </button>
                        <div className="modal-image">
                            <img src={`${url}portfoilo/${selectedItem.image}`} alt={selectedItem.title} />

                        </div>
                        <div className="modal-details">
                            <h2>{selectedItem.title}</h2>
                            <div className="detail-row">
                                <span className="detail-label">Category:</span>
                                <span className="detail-value">{selectedItem.category}</span>
                            </div>
                            <div className="detail-row">
                                <span className="detail-label">Description:</span>
                                <p className="detail-value">{selectedItem.description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdminDashboard;